import { render, staticRenderFns } from "./SupBody.vue?vue&type=template&id=76095787&scoped=true&"
import script from "./SupBody.vue?vue&type=script&lang=js&"
export * from "./SupBody.vue?vue&type=script&lang=js&"
import style0 from "./SupBody.vue?vue&type=style&index=0&id=76095787&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76095787",
  null
  
)

export default component.exports